export default __webpack_public_path__ + "static/media/banner-simples-sem-img.05f9da42.svg";